import React from "react";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.data;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;

        return (
            <div style={{ padding: '20px' }}>
                <style>
                    {`
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-top: 20px;
                        }
                        
                        .report-table th,
                        .report-table td {
                            border: 1px solid #000;
                            padding: 8px;
                            text-align: left;
                        }
                        
                        .report-table th {
                            background-color: #ffffff;
                            font-weight: bold;
                        }
                        
                        .info-section {
                            margin-bottom: 20px;
                        }
                        
                        .info-row {
                            display: flex;
                            margin-bottom: 10px;
                        }
                        
                        .info-label {
                            font-weight: bold;
                            margin-right: 5px;
                        }
                    `}
                </style>

                <h3 style={{ textAlign: 'center', textDecoration: 'underline', marginBottom: '30px' }}>
                    Goods Transfer Details Report
                </h3>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', fontSize: '14px' }}>
                    <div><span style={{ fontWeight: 'bold' }}>Group:</span> {searchData.group}</div>
                    <div><span style={{ fontWeight: 'bold' }}>Operation Entity:</span> {searchData.estate}</div>
                    <div><span style={{ fontWeight: 'bold' }}>Collection Point:</span> {searchData.division}</div>
                    <div><span style={{ fontWeight: 'bold' }}>Date:</span> {searchData.date}</div>
                </div>
                {keys.map((e, index) => {
                    const gtnData = data[e][0];

                    return (
                        <div key={index} style={{ marginBottom: '40px', pageBreakInside: 'avoid' }}>
                            <div className="info-section">
                                <div style={{ marginBottom: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>GTN Number:</span>
                                    <br />
                                    {gtnData.gtnNumber}
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>Collection Point Name:</span>
                                    <br />
                                    {gtnData.collectionPointName}
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>Transferred To:</span>
                                    <br />
                                    {gtnData.transferedTo}
                                </div>

                                <div style={{ marginBottom: '10px' }}>
                                    <span style={{ fontWeight: 'bold' }}>Transfer Note:</span>
                                    <br />
                                    {gtnData.transferNote}
                                </div>
                            </div>
                            <table className="report-table">
                                <thead>
                                    <tr>
                                        <th>Field Name</th>
                                        <th>Total Amount (Kg)</th>
                                        <th>Deduction (Kg)</th>
                                        <th>Net Amount (Kg)</th>
                                        <th>Bag Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data[e].map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>{row.fieldName || '-'}</td>
                                            <td>{row.totalAmount || '0'}</td>
                                            <td>{row.deduction || '0'}</td>
                                            <td>{row.netAmount || '0'}</td>
                                            <td>{row.bagCount || '0'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div>
        );
    }
}